module.exports = __webpack_public_path__ + "img/m-empty.f3939e41.png";